import { render } from "./ContactResultPage.vue?vue&type=template&id=ac6e1fb8"
import script from "./ContactResultPage.vue?vue&type=script&lang=js"
export * from "./ContactResultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__